import { Helmet } from 'react-helmet-async';

export default function ImpressumPage() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://optimistic-news.com/impressum" />
        <title>Impressum - Optimistic News</title>
        <meta
          name="description"
          content="Impressum (Legal Disclosure) for Optimistic News pursuant to § 5 DDG."
        />
      </Helmet>
      <div className="py-16 px-4 sm:px-6 lg:px-8 max-w-4xl mx-auto prose dark:prose-invert">
        <h1>Impressum</h1>
        <p>
          Angaben gemäß § 5 DDG (Digitale-Dienste-Gesetz) / Legal disclosure
          pursuant to § 5 DDG.
        </p>

        <h2>Anbieter / Provider</h2>
        <p>
          Hannah
          <br />
          Am Botten, 53179 Bonn
        </p>

        <h2>Kontakt / Contact</h2>
        <p>
          E-Mail:{' '}
          <a href="mailto:privacy@optimistic-news.com">
            privacy@optimistic-news.com
          </a>
          <br />
          Telefon / Phone: +49 228 43389999
        </p>

        <h2>
          Verantwortlicher für journalistisch-redaktionelle Inhalte gemäß § 18
          Abs. 2 MStV
        </h2>
        <p>
          Verantwortlicher im Sinne des § 18 Abs. 2 Medienstaatsvertrag (MStV):
        </p>
        <p>
          Hannah
          <br />
          Am Botten, 53179 Bonn
        </p>

        <h2>Disclaimer</h2>

        <h3>Haftung für Inhalte / Liability for Content</h3>
        <p>
          Die Inhalte dieser Website wurden mit größter Sorgfalt erstellt. Für
          die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir
          jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7
          Abs. 1 DDG für eigene Inhalte auf diesen Seiten nach den allgemeinen
          Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als
          Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
          gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
          forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p>
          The content on this website has been created with the utmost care.
          However, we cannot guarantee the accuracy, completeness, or up-to-date
          nature of the content. As a service provider, we are responsible for
          our own content on these pages in accordance with general legislation
          pursuant to § 7 (1) DDG. Pursuant to §§ 8–10 DDG, however, we as a
          service provider are not obliged to monitor transmitted or stored
          third-party information or to investigate circumstances that indicate
          illegal activity.
        </p>

        <h3>Haftung für Links / Liability for Links</h3>
        <p>
          Unser Angebot enthält Links zu externen Websites Dritter, auf deren
          Inhalte wir keinen Einfluss haben. Deshalb können wir für diese
          fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der
          verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der
          Seiten verantwortlich.
        </p>
        <p>
          Our offering contains links to external third-party websites, the
          content of which we have no influence over. We therefore cannot accept
          any liability for such external content. The respective provider or
          operator of the linked pages is always responsible for their content.
        </p>

        <h3>Urheberrecht / Copyright</h3>
        <p>
          Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
          Seiten unterliegen dem deutschen Urheberrecht. Beiträge Dritter sind
          als solche gekennzeichnet. Die Vervielfältigung, Bearbeitung,
          Verbreitung und jede Art der Verwertung außerhalb der Grenzen des
          Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen
          Autors bzw. Erstellers.
        </p>
        <p>
          The content and works created by the site operators on these pages are
          subject to German copyright law. Third-party contributions are
          identified as such. Reproduction, processing, distribution, and any
          form of commercialisation beyond the scope of copyright law require
          the written consent of the respective author or creator.
        </p>
      </div>
    </>
  );
}
